import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import './fonts/helvetica/HelveticaNeueLight.otf';
import './fonts/helvetica/HelveticaNeueMedium.otf';
import './fonts/helvetica/HelveticaNeueRoman.otf';
import './fonts/splekta/splekta.ttf';
import "./global.css";
import "./i18n/i18n";
import Suspense from "./pages/suspence/page";
import store, { persistor } from "./redux";
import SeoLanding from "./Seo/SeoLanding";
// import { HelmetProvider } from "react-helmet-async";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.Suspense fallback={<Suspense />}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
      {/* <HelmetProvider> */}
        {/* <LandingSeo /> */}
        <SeoLanding />
        <App />
        {/* </HelmetProvider> */}
      </PersistGate>
    </Provider>
  </React.Suspense>
);
